export enum TaxType {
    GST_TAX = 'GSTTAX',
    PST_TAX = 'PSTTAX',
    SLS_TAX = 'SLSTAX',
    NOR = 'NOR',
    SHP = 'SHP',
    HND = 'HND'

}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/tax-type.interface.ts